<template>
  <div>
    <div class="row">
      <div class="col-12">
        <br />

        <div
          class="modal fade"
          id="modalExistencias"
          role="dialog"
          tabindex="-1"
          aria-hidden="true"
          style="display: none"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Inventario en estación</h5>
                <button
                  aria-label="Close"
                  class="close"
                  data-dismiss="modal"
                  type="button"
                >
                  <span aria-hidden="true"> ×</span>
                </button>
              </div>
              <div class="modal-body">
                <table class="table table-compact smaller text-faded mb-0">
                  <thead>
                    <tr>
                      <th>Producto</th>
                      <th>Lote</th>
                      <th>Cantidad</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="existencia in existencias" :key="existencia.id">
                      <td class="text-bright">
                        {{ existencia.sku }} - {{ existencia.nombre_sku }}
                      </td>
                      <td class="text-right">
                        {{ existencia.codigo_lote }}
                      </td>
                      <td class="text-right text-success">
                        {{ existencia.cantidad }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="error_finalizar">
        <small class="form-text text-danger">
          {{ error_finalizar }}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  props: {
    id_tarima: {
      type: String,
    },
  },
  data() {
    return {
      barra_estacion: "",
      error_estacion: null,
      error_finalizar: null,
      existencias: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
  },
};
</script>
